import { struct } from 'io-ts/Decoder';

import { Id as MaterialId } from '../../../../whole-house/material/Id';

export const Params = struct({
	materialId: MaterialId,
});
